export default {
  sessions: {
    leader: {
      session_0: ['selectCoach'],
      session_1: [],
      session_2: ['finalizeLGA'],
      session_3: ['finalizeLGA', 'finalizeStakeholder'],
      session_4: ['finalizeStakeholder', 'publishAP'],
      session_5: ['publishAP'],
      session_6: ['publishAP', 'doPulseSurvey'],
      session_7: ['publishAP'],
      session_8: ['publishAP'],
      session_9: ['publishAP', 'doPulseSurvey'],
      session_10: ['publishAP'],
      session_11: ['publishAP'],
      session_12: ['publishAP', 'doPulseSurvey'],
      session_13: ['publishAP'],
    },
    coach: {
      // session_0: [],
      session_1: ['reviewAgendaForSession1'],
      after_1: ['reviewLeader360Data', 'reviewNextMeeting'],
      // session_2: [],
      // session_3: [],
      // session_4: [],
      // session_5: [],
      // session_6: [],
      // session_7: [],
      // session_8: [],
      // session_9: [],
      // session_10: [],
    },
  },
};
